import { render, staticRenderFns } from "./CollegeLibrary.vue?vue&type=template&id=b04409ec&scoped=true"
import script from "./CollegeLibrary.vue?vue&type=script&lang=js"
export * from "./CollegeLibrary.vue?vue&type=script&lang=js"
import style0 from "./CollegeLibrary.vue?vue&type=style&index=0&id=b04409ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04409ec",
  null
  
)

export default component.exports